module.exports = __webpack_public_path__ + "static/madeline_cherry-29cedc5abe0edb8f3e0998a683349607.jpg";